import { WebPlugin } from '@capacitor/core';

import type { ExampleMediaSessionPluginPlugin } from './definitions';

export class ExampleMediaSessionPluginWeb extends WebPlugin implements ExampleMediaSessionPluginPlugin {
  async echo(options: { value: string }): Promise<{ value: string }> {
    console.log('ECHO', options);
    return options;
  }
}
